import React from 'react';
import { Canvas } from '@react-three/fiber';
import { TowerEffect, TowerEffectView } from './index.js'; // Import TowerEffect
import { r3f } from './global';

const viewStyle = {
  position: 'absolute',
  top: 0,
  left: '-40%',
  width: '100%',
  height: '100%',
};

function App() {

  return (
    <div style={{ width: '100vw', height: '100vh', position: 'fixed' }}>
      <TowerEffectView style={viewStyle} orbit>
        <TowerEffect />
      </TowerEffectView>

      <Canvas
        style={{
          transitionDuration: 0,
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          pointerEvents: 'none',
        }}
      >
        <r3f.Out />
      </Canvas>
    </div>
  );
}

export default App;
